var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCloseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_close_big",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_close"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7781746,2.80761184 L21.1923882,4.22182541 L13.4136118,11.9996118 L21.1923882,19.7781746 L19.7781746,21.1923882 L11.9996118,13.4136118 L4.22182541,21.1923882 L2.80761184,19.7781746 L10.5856118,11.9996118 L2.80761184,4.22182541 L4.22182541,2.80761184 L11.9996118,10.5856118 L19.7781746,2.80761184 Z",
    id: "shape_x",
    fill: "#2D72FE",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCloseBig);
export default __webpack_public_path__ + "static/media/icn_close_big.0c8c93bce580d7b95996f2c7154ee6a1.svg";
export { ForwardRef as ReactComponent };